export const PAGE_SETTINGS_DEFAULTS = {
  meta: {
    title: "Speedway Games",
    description:
      "Speedway Games is an Independent game developer and publisher that builds top games on the Roblox platform.",
    keywords:
      "Roblox game studio, Speedway Games, Roblox developers, Vehicle Legends, Mansion Tycoon, gaming experience, remote jobs, global players, industry professionals",
    ogImage: "/preview_v2.png",
    favicon: "/favicon.webp",
  },
  cover: {
    backgroundUri: "/page-cover.webp",
    title: null,
  },
};
